// extracted by mini-css-extract-plugin
export var alt = "Title3-module--alt--52f28";
export var desktopOnly = "Title3-module--desktopOnly--bf00c";
export var main = "Title3-module--main--21339";
export var mobileOnly = "Title3-module--mobileOnly--8fe78";
export var styledH3 = "Title3-module--styledH3--ca627";
export var textLeft = "Title3-module--textLeft--0890b";
export var visuallyHidden = "Title3-module--visuallyHidden--45468";